import { __extends } from "tslib";
import styles from './IframeManager.scss';
import { WindowManager } from './WindowManager';
var IframeManager = /** @class */ (function (_super) {
    __extends(IframeManager, _super);
    function IframeManager() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IframeManager.prototype.create = function (_a) {
        var src = _a.src, frameId = _a.frameId, appendTo = _a.appendTo;
        if (this.iframe && this.iframe.src === src) {
            if (!this.iframe.contentWindow) {
                throw new Error('No content window');
            }
            return this.iframe.contentWindow;
        }
        if (this.iframe) {
            this.destroy();
        }
        this.iframe = document.createElement('iframe');
        this.iframe.allowFullscreen = true;
        this.iframe.setAttribute('allow', 'autoplay; camera; microphone; geolocation; vr');
        this.iframe.setAttribute('allowtransparency', 'true');
        if (frameId) {
            this.iframe.id = frameId;
        }
        this.hide();
        this.iframe.src = src;
        this.iframe.className = styles.frame;
        var parent = this.getAppendTo(appendTo);
        parent.appendChild(this.iframe);
        this.logger.log('iFrame created', this.iframe);
        if (!this.iframe.contentWindow) {
            throw new Error('No content window');
        }
        return this.iframe.contentWindow;
    };
    IframeManager.prototype.destroy = function () {
        if (!this.iframe) {
            return;
        }
        if (this.iframe.parentNode) {
            this.iframe.parentNode.removeChild(this.iframe);
        }
        this.iframe = undefined;
        this.logger.log('iFrame killed');
    };
    IframeManager.prototype.show = function () {
        if (this.iframe) {
            this.iframe.style.display = 'block';
            if (this.iframe.contentWindow) {
                this.iframe.contentWindow.focus();
            }
        }
    };
    IframeManager.prototype.hide = function () {
        if (this.iframe) {
            this.iframe.style.display = 'none';
        }
    };
    IframeManager.prototype.getOpenerWindow = function () {
        return window.parent;
    };
    IframeManager.prototype.getAppendTo = function (appendTo) {
        if (appendTo instanceof HTMLElement) {
            return appendTo;
        }
        var element = document.querySelector(appendTo);
        if (!element) {
            throw new Error("Cannot find element to appendTo by selector '" + appendTo + "'");
        }
        return element;
    };
    return IframeManager;
}(WindowManager));
export { IframeManager };
//# sourceMappingURL=IframeManager.js.map